import { formatDate } from "./date";

export const validateEncountersForSubmit = encounters => {
  const errors = [];
  encounters.forEach(encounter => {
    if (!encounter.provider)
      errors.push(
        `Encounter for ${encounter.patient} on ${formatDate(
          encounter.date
        )}: Missing provider`
      );
    if (!encounter.services || encounter.services.length <= 0)
      errors.push(
        `Encounter for ${encounter.patient} on ${formatDate(
          encounter.date
        )}: Missing service`
      );
    if (!encounter.diagnosisCodes || encounter.diagnosisCodes.length <= 0)
      errors.push(
        `Encounter for ${encounter.patient} on ${formatDate(
          encounter.date
        )}: Missing diagnosis codes`
      );
  });
  return errors;
};
